import * as Sentry from '@sentry/react';

import { ENV_MODE, SENTRY_DSN, SENTRY_ENVIRONMENT } from '@/configs';

Sentry.init({
  dsn: SENTRY_DSN,
  integrations: [Sentry.replayIntegration()],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: SENTRY_ENVIRONMENT,
  enabled: ENV_MODE !== 'development',
});
